export const statisticsFr = {
  "Versement": "Versement",
  "Comptabilité": "Comptabilité",
  "Pourcentage": "Pourcentage",
  "soins": "soins",
  "Mode de paiement": "Mode de paiement",
  "Total Restante": "Total Restante",
  "Statistiques Financières": "Statistiques Financières",
}